import React from 'react';
import Button from 'shared/components/andtComponents/Button';
import ActivateCustomerModal from './customerModals/ActivateCustomer';
import { ICustomersTableRow } from './types/customers'
import styles from './CustomerActivation.module.scss';
import ReadOnlyDisplayWrapper from 'shared/components/ReadOnlyDisplayWrapper.jsx';
import { Action, OrganizationEntityCategory, CategoryAction } from '@anodot-cost/rbac-client';

interface ICustomerActivationProps {
  row: ICustomersTableRow;
}

const CustomerActivation = ({ row }: ICustomerActivationProps) => {
  const [isActivateCustomerModalOpen, setIsActivateCustomerModalOpen] = React.useState(false);
  const requiredPremissions = [
    { category: OrganizationEntityCategory.ResellerCustomers, action: Action.Update },
    { category: OrganizationEntityCategory.ResellerCustomers, action: CategoryAction.Create }
  ];
  return(<>{
    !row.isOrgCreated &&
    <ReadOnlyDisplayWrapper
      isHide={false}
      oneOfCategoryActionList={requiredPremissions}
      category={null}
      action={null}
      legacyUserTypeList={null}
    >
      <Button
        text="Activate"
        automationid={`activateCustomerButton-${row.id}`}
        onClick={(e) => { e.stopPropagation(); setIsActivateCustomerModalOpen(true); }}
        className={{ button: styles.activateButton}}
      />
    </ReadOnlyDisplayWrapper>
  }
  {isActivateCustomerModalOpen && (
        <ActivateCustomerModal setIsOpen={setIsActivateCustomerModalOpen} isOpen={isActivateCustomerModalOpen} customer={row} />
      )}</>);
};

export default CustomerActivation;
